
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/notes?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/notes/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/notes`, payload);
    return response.data;
  },
  async update(id, payload) {
    console.log(payload,'payload')
    const response = await https.post(`/notes/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/notes/${id}`);
    return response.data;
  },
});
